import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** An ISO 8601-encoded datetime */
  ISO8601DateTime: { input: any; output: any; }
};

/** 認証情報 */
export type Authentication = {
  __typename?: 'Authentication';
  /** 教室情報 */
  printOffice: PrintOffice;
  /** トークン */
  token: Scalars['String']['output'];
};

/** Autogenerated input type of DeleteAllPrintedJobs */
export type DeleteAllPrintedJobsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of DeleteAllPrintedJobs. */
export type DeleteAllPrintedJobsPayload = {
  __typename?: 'DeleteAllPrintedJobsPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** エラーリスト */
  errors: Array<Error>;
};

/** Autogenerated input type of DeletePrintJob */
export type DeletePrintJobInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** 印刷ジョブID */
  printJobId: Scalars['ID']['input'];
};

/** Autogenerated return type of DeletePrintJob. */
export type DeletePrintJobPayload = {
  __typename?: 'DeletePrintJobPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** エラーリスト */
  errors: Array<Error>;
};

/** エラー */
export type Error = {
  __typename?: 'Error';
  /** エラーメッセージ */
  message: Scalars['String']['output'];
  /** エラー項目名称 */
  name: Scalars['String']['output'];
  /** エラー種類 */
  type: Scalars['String']['output'];
};

/** Autogenerated input type of Login */
export type LoginInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** 印刷コード */
  printCode: Scalars['String']['input'];
};

/** Autogenerated return type of Login. */
export type LoginPayload = {
  __typename?: 'LoginPayload';
  /** 認証情報 */
  authentication?: Maybe<Authentication>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** エラーリスト */
  errors: Array<Error>;
};

export type Mutation = {
  __typename?: 'Mutation';
  /** ログイン中の店舗の印刷済みジョブをすべて削除 */
  deleteAllPrintedJobs: DeleteAllPrintedJobsPayload;
  /** 印刷ジョブ削除 */
  deletePrintJob: DeletePrintJobPayload;
  /**
   * ログイン
   *
   * errors
   * - type: not_found
   *   - name: print_code (教室が存在しない場合)
   */
  login?: Maybe<LoginPayload>;
  /** 指定された印刷ジョブのステータスを印刷済みと最終印刷日時に更新する */
  updatePrintJobStatusAndLastPrintedAt: UpdatePrintJobStatusAndLastPrintedAtPayload;
};


export type MutationDeleteAllPrintedJobsArgs = {
  input: DeleteAllPrintedJobsInput;
};


export type MutationDeletePrintJobArgs = {
  input: DeletePrintJobInput;
};


export type MutationLoginArgs = {
  input: LoginInput;
};


export type MutationUpdatePrintJobStatusAndLastPrintedAtArgs = {
  input: UpdatePrintJobStatusAndLastPrintedAtInput;
};

/** Information about pagination in a connection. */
export type PageInfo = {
  __typename?: 'PageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']['output']>;
};

/** 印刷ジョブ */
export type PrintJob = {
  __typename?: 'PrintJob';
  /** 概要 */
  description?: Maybe<Scalars['String']['output']>;
  /** id */
  id: Scalars['ID']['output'];
  /** 印刷コード */
  printCode: Scalars['String']['output'];
  /** 印刷キュー登録日時 */
  printOrderedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** 問題数 */
  questionCount: Scalars['Int']['output'];
  /** ステータス */
  status: StatusEnum;
  /** 印刷対象者 */
  targetName: Scalars['String']['output'];
  /** 印刷用PDFのURL */
  url?: Maybe<Scalars['String']['output']>;
};

/** The connection type for PrintJob. */
export type PrintJobConnection = {
  __typename?: 'PrintJobConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<PrintJobEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<PrintJob>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type PrintJobEdge = {
  __typename?: 'PrintJobEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<PrintJob>;
};

/** 教室情報 */
export type PrintOffice = {
  __typename?: 'PrintOffice';
  /** id */
  id: Scalars['ID']['output'];
  /** 店舗名 */
  name: Scalars['String']['output'];
  /** 店舗コード */
  officeCode: Scalars['String']['output'];
  /** 印刷コード */
  printCode: Scalars['String']['output'];
};

export type Query = {
  __typename?: 'Query';
  /** 印刷ジョブ取得 */
  getPrintJob?: Maybe<PrintJob>;
  /** ログイン済みの教室に紐づく印刷ジョブ一覧を取得 */
  getPrintJobs: PrintJobConnection;
};


export type QueryGetPrintJobArgs = {
  printJobId: Scalars['ID']['input'];
};


export type QueryGetPrintJobsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  printed: Scalars['Boolean']['input'];
};

/** ステータス */
export enum StatusEnum {
  /** エラー */
  Error = 'ERROR',
  /** 未印刷 */
  NotPrinted = 'NOT_PRINTED',
  /** 印刷済み */
  Printed = 'PRINTED'
}

/** Autogenerated input type of UpdatePrintJobStatusAndLastPrintedAt */
export type UpdatePrintJobStatusAndLastPrintedAtInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** 印刷ジョブのID */
  printJobId: Scalars['ID']['input'];
};

/** Autogenerated return type of UpdatePrintJobStatusAndLastPrintedAt. */
export type UpdatePrintJobStatusAndLastPrintedAtPayload = {
  __typename?: 'UpdatePrintJobStatusAndLastPrintedAtPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** エラーリスト */
  errors: Array<Error>;
};

export type GetPrintJobsQueryVariables = Exact<{
  printed: Scalars['Boolean']['input'];
}>;


export type GetPrintJobsQuery = { __typename?: 'Query', getPrintJobs: { __typename?: 'PrintJobConnection', nodes?: Array<{ __typename?: 'PrintJob', id: string, description?: string | null, targetName: string, questionCount: number, status: StatusEnum, printOrderedAt?: any | null, printCode: string, url?: string | null } | null> | null } };

export type GetPrintJobQueryVariables = Exact<{
  printJobId: Scalars['ID']['input'];
}>;


export type GetPrintJobQuery = { __typename?: 'Query', getPrintJob?: { __typename?: 'PrintJob', id: string, description?: string | null, targetName: string, questionCount: number, status: StatusEnum, printOrderedAt?: any | null, printCode: string, url?: string | null } | null };

export type UpdatePrintJobStatusMutationVariables = Exact<{
  input: UpdatePrintJobStatusAndLastPrintedAtInput;
}>;


export type UpdatePrintJobStatusMutation = { __typename?: 'Mutation', updatePrintJobStatusAndLastPrintedAt: { __typename?: 'UpdatePrintJobStatusAndLastPrintedAtPayload', errors: Array<{ __typename?: 'Error', message: string, name: string, type: string }> } };

export type DeletePrintJobMutationVariables = Exact<{
  input: DeletePrintJobInput;
}>;


export type DeletePrintJobMutation = { __typename?: 'Mutation', deletePrintJob: { __typename?: 'DeletePrintJobPayload', errors: Array<{ __typename?: 'Error', message: string, name: string, type: string }> } };

export type LoginMutationVariables = Exact<{
  input: LoginInput;
}>;


export type LoginMutation = { __typename?: 'Mutation', login?: { __typename?: 'LoginPayload', authentication?: { __typename?: 'Authentication', token: string, printOffice: { __typename?: 'PrintOffice', id: string, name: string, officeCode: string, printCode: string } } | null, errors: Array<{ __typename?: 'Error', message: string, name: string, type: string }> } | null };


export const GetPrintJobsDocument = gql`
    query GetPrintJobs($printed: Boolean!) {
  getPrintJobs(printed: $printed, first: 100) {
    nodes {
      id
      description
      targetName
      questionCount
      status
      printOrderedAt
      printCode
      url
    }
  }
}
    `;

/**
 * __useGetPrintJobsQuery__
 *
 * To run a query within a React component, call `useGetPrintJobsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPrintJobsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPrintJobsQuery({
 *   variables: {
 *      printed: // value for 'printed'
 *   },
 * });
 */
export function useGetPrintJobsQuery(baseOptions: Apollo.QueryHookOptions<GetPrintJobsQuery, GetPrintJobsQueryVariables> & ({ variables: GetPrintJobsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPrintJobsQuery, GetPrintJobsQueryVariables>(GetPrintJobsDocument, options);
      }
export function useGetPrintJobsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPrintJobsQuery, GetPrintJobsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPrintJobsQuery, GetPrintJobsQueryVariables>(GetPrintJobsDocument, options);
        }
export function useGetPrintJobsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPrintJobsQuery, GetPrintJobsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPrintJobsQuery, GetPrintJobsQueryVariables>(GetPrintJobsDocument, options);
        }
export type GetPrintJobsQueryHookResult = ReturnType<typeof useGetPrintJobsQuery>;
export type GetPrintJobsLazyQueryHookResult = ReturnType<typeof useGetPrintJobsLazyQuery>;
export type GetPrintJobsSuspenseQueryHookResult = ReturnType<typeof useGetPrintJobsSuspenseQuery>;
export type GetPrintJobsQueryResult = Apollo.QueryResult<GetPrintJobsQuery, GetPrintJobsQueryVariables>;
export const GetPrintJobDocument = gql`
    query GetPrintJob($printJobId: ID!) {
  getPrintJob(printJobId: $printJobId) {
    id
    description
    targetName
    questionCount
    status
    printOrderedAt
    printCode
    url
  }
}
    `;

/**
 * __useGetPrintJobQuery__
 *
 * To run a query within a React component, call `useGetPrintJobQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPrintJobQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPrintJobQuery({
 *   variables: {
 *      printJobId: // value for 'printJobId'
 *   },
 * });
 */
export function useGetPrintJobQuery(baseOptions: Apollo.QueryHookOptions<GetPrintJobQuery, GetPrintJobQueryVariables> & ({ variables: GetPrintJobQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPrintJobQuery, GetPrintJobQueryVariables>(GetPrintJobDocument, options);
      }
export function useGetPrintJobLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPrintJobQuery, GetPrintJobQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPrintJobQuery, GetPrintJobQueryVariables>(GetPrintJobDocument, options);
        }
export function useGetPrintJobSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPrintJobQuery, GetPrintJobQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPrintJobQuery, GetPrintJobQueryVariables>(GetPrintJobDocument, options);
        }
export type GetPrintJobQueryHookResult = ReturnType<typeof useGetPrintJobQuery>;
export type GetPrintJobLazyQueryHookResult = ReturnType<typeof useGetPrintJobLazyQuery>;
export type GetPrintJobSuspenseQueryHookResult = ReturnType<typeof useGetPrintJobSuspenseQuery>;
export type GetPrintJobQueryResult = Apollo.QueryResult<GetPrintJobQuery, GetPrintJobQueryVariables>;
export const UpdatePrintJobStatusDocument = gql`
    mutation UpdatePrintJobStatus($input: UpdatePrintJobStatusAndLastPrintedAtInput!) {
  updatePrintJobStatusAndLastPrintedAt(input: $input) {
    errors {
      message
      name
      type
    }
  }
}
    `;
export type UpdatePrintJobStatusMutationFn = Apollo.MutationFunction<UpdatePrintJobStatusMutation, UpdatePrintJobStatusMutationVariables>;

/**
 * __useUpdatePrintJobStatusMutation__
 *
 * To run a mutation, you first call `useUpdatePrintJobStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePrintJobStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePrintJobStatusMutation, { data, loading, error }] = useUpdatePrintJobStatusMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePrintJobStatusMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePrintJobStatusMutation, UpdatePrintJobStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePrintJobStatusMutation, UpdatePrintJobStatusMutationVariables>(UpdatePrintJobStatusDocument, options);
      }
export type UpdatePrintJobStatusMutationHookResult = ReturnType<typeof useUpdatePrintJobStatusMutation>;
export type UpdatePrintJobStatusMutationResult = Apollo.MutationResult<UpdatePrintJobStatusMutation>;
export type UpdatePrintJobStatusMutationOptions = Apollo.BaseMutationOptions<UpdatePrintJobStatusMutation, UpdatePrintJobStatusMutationVariables>;
export const DeletePrintJobDocument = gql`
    mutation DeletePrintJob($input: DeletePrintJobInput!) {
  deletePrintJob(input: $input) {
    errors {
      message
      name
      type
    }
  }
}
    `;
export type DeletePrintJobMutationFn = Apollo.MutationFunction<DeletePrintJobMutation, DeletePrintJobMutationVariables>;

/**
 * __useDeletePrintJobMutation__
 *
 * To run a mutation, you first call `useDeletePrintJobMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePrintJobMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePrintJobMutation, { data, loading, error }] = useDeletePrintJobMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeletePrintJobMutation(baseOptions?: Apollo.MutationHookOptions<DeletePrintJobMutation, DeletePrintJobMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeletePrintJobMutation, DeletePrintJobMutationVariables>(DeletePrintJobDocument, options);
      }
export type DeletePrintJobMutationHookResult = ReturnType<typeof useDeletePrintJobMutation>;
export type DeletePrintJobMutationResult = Apollo.MutationResult<DeletePrintJobMutation>;
export type DeletePrintJobMutationOptions = Apollo.BaseMutationOptions<DeletePrintJobMutation, DeletePrintJobMutationVariables>;
export const LoginDocument = gql`
    mutation Login($input: LoginInput!) {
  login(input: $input) {
    authentication {
      token
      printOffice {
        id
        name
        officeCode
        printCode
      }
    }
    errors {
      message
      name
      type
    }
  }
}
    `;
export type LoginMutationFn = Apollo.MutationFunction<LoginMutation, LoginMutationVariables>;

/**
 * __useLoginMutation__
 *
 * To run a mutation, you first call `useLoginMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLoginMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [loginMutation, { data, loading, error }] = useLoginMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useLoginMutation(baseOptions?: Apollo.MutationHookOptions<LoginMutation, LoginMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LoginMutation, LoginMutationVariables>(LoginDocument, options);
      }
export type LoginMutationHookResult = ReturnType<typeof useLoginMutation>;
export type LoginMutationResult = Apollo.MutationResult<LoginMutation>;
export type LoginMutationOptions = Apollo.BaseMutationOptions<LoginMutation, LoginMutationVariables>;